// extracted by mini-css-extract-plugin
module.exports = {"model":"index_model_3oN0P","left":"index_left_2m3MI","right":"index_right_3SHsP","card":"index_card_2xHWV","textOverflow":"index_textOverflow_Eh-cU"};